/*
 * @Author: Merlin
 * @Date: 2024-05-29 16:47:38
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-21 13:56:35
 * @Description: 
 */
import { getServerSideTK, deCodeToken } from '~/stores/auth';
import { useProfileSocket } from '@/socket/profile';
import type { UserInfo } from '@/socket/profile/dto/index';
import useGlobalStore from '@/stores/global';

// 记录最近发出的接口请求及入参，用于在 packet 级别报错时辅助定位接口名和入参
const PENDING_EVENTS_MAX = 20;
export interface PendingEvent { eventName: string; params: any; }
export const pendingEvents: PendingEvent[] = [];

export function asyncEmit<T>(
    eventName, // 接口地址 
    data,
) {
    console.log(
        '%c API ',
        'background:#409EFF;color:#fff;padding:2px 6px;border-radius:3px;',
        eventName,
        '参数:',
        import.meta.client ? data : JSON.stringify(data),
    );
    return new Promise<T>(function (resolve, reject) {
        // console.log('WS链接良好性：', !socket.disconnected, useGlobalStore().wsConnection); 
        // 说明：useGlobalStore().wsConnection 的默认值是 true 表示链接良好（在链接还没建立时就是 true）
        // 那么此值一旧为 false 那么表示曾成功过，现在断开了、或首次建立链接就没成功 
        if (socket.disconnected && !useGlobalStore().wsConnection) {
            return reject(new Error('WebSocket Error'));
        }
        const entry: PendingEvent = { eventName, params: data };
        pendingEvents.push(entry);
        if (pendingEvents.length > PENDING_EVENTS_MAX) pendingEvents.shift();
        socket.emit(eventName, data, (result: T) => {
            const idx = pendingEvents.indexOf(entry);
            if (idx !== -1) pendingEvents.splice(idx, 1);
            resolve(result);
        });
    });
}

interface LoginState {
    hasLogged: boolean;
}
interface UserInfoPlus extends UserInfo, LoginState {
    // 无
}

// ↓ 查询用户信息（也用于查询用户是否登录）  
// ↓ 这是一个 “记忆化函数，有缓存函数” 多次调用只不会重复查询  
export const getUserInfo = (()=>{
    const { EMIT_PROFILE_TOKEN } = useProfileSocket();
    const p01 = {
        promise: null,
        resolve: null,
        reject: null,
    };
    // ↓ 最终返回的函数 
    async function theFn(
        // noCache:false, // 收到了 true 则不使用缓存（将来考虑上线）
    ):(
        Promise<LoginState | UserInfoPlus>
    ){
        const token = getServerSideTK() || deCodeToken(); 
        let hasLogged = false; // 默认没登录 
        if (!token) {
            // ↓ 如果没有 token ，甚至要推翻之前的查询结果，认定用户没登录
            // ↓ 因为在特定情况下 token 可能被销毁 
            return {hasLogged}; // 没登录
        }
        if (p01.promise) {
            return p01.promise; // 返回缓存 
        }
        Object.assign(p01, createPromise());
        const oRes = await EMIT_PROFILE_TOKEN({
            token,
            fingerprint: 'Not-implemented',
        });
        const id = oRes?.user?._id;
        // ↓ 表示已经登录了（问过了，用户 id 从1开始） 
        hasLogged = (id > 0) && (typeof id === 'number');
        if (oRes){
            Object.assign(oRes, {hasLogged});
        }
        // console.log("💥\n💥\n💥\n💥\n💥\n查询用户信息完成了", oRes);
        p01.resolve(oRes);
        return p01.promise;
    }
    return theFn;
})();

